import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface CancelContractProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class CancelContract extends React.Component<CancelContractProps> {

    @observable private contract: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [
        "retired_by",
        "equipment_retired",
        "retired_date"
    ];

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/contract/read/${id}`).then((response) => {
            this.contract = response.data;
            this.contract.retired_by = "";
            this.contract.equipment_retired = "";
            this.contract.retired_date = "";
        })
            .then(() => {
                this.isLoaded = true;
            })
            .catch(() => {
                toast.error("Error cargando contrato");
            });
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.contract[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        if (this.contract.id.toString().startsWith("W")) {
            this.contract.id = this.contract.id.substring(1);
        }

        this.contract.closed_by = sessionService.getUserInfo().id;
        http.post(`/api/contract/cancelar`, JSON.stringify(this.contract))
            .then(() => {
                toast.success(`Contrato actualizado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }

        if (this.redirect) {
            return <Redirect to="/contratos" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Cancelar contrato #{this.contract.id} - {this.contract.address_street} {this.contract.address_colonia}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../contratos`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Cancelar contrato</button>
                                    </div>
                                </div>
                                <InputForm
                                    name="retired_by"
                                    label="Retirado por"
                                    value={this.contract.retired_by}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="equipment_retired"
                                    label="Equipo Retirado"
                                    value={this.contract.equipment_retired}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="retired_date"
                                    label="Fecha de Retiro (año-mes-dia)"
                                    value={this.contract.retired_date}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="number"
                                    format={"####-##-##"}
                                />
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Cancelar contrato</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}